import { render } from "./HeroiconsSolidClipboardCheck.vue?vue&type=template&id=21d124e0"
const script = {}

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidClipboardCheck.vue"]])

export default __exports__